<template>
  <div>
    <TicketUseApp></TicketUseApp>
  </div>
</template>

<script>
// @ is an alias to /src
import TicketUseApp from "@/components/TicketUseApp.vue";

export default {
  name: "TicketUse",
  components: {
    TicketUseApp
  }
};
</script>
<style scoped>
h1 {
  font-family: YuGo;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.5;
  letter-spacing: normal;
  text-align: left;
  color: #151515;
  padding-top: 30px;
  padding-bottom: 0px;
  width: 355px;
  margin-left: auto;
  margin-right: auto;
}
</style>
